import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import moment from 'moment';
import Collapse, { Panel } from 'rc-collapse';

import '../../assets/styles/components/_tables.scss';
import '../../assets/styles/components/_modal.scss';
import './precious-metals.scss';

import EditIcon from '../../assets/icons/edit.svg';
import CrossIcon from '../../assets/icons/cross.svg';

import { cashBoxService } from '../../services/cashbox-service';
import { HInput, HookForm } from '../../validation/HForm';
import { purityGroupScheme } from '../../validation/scheme/purityGroupScheme';
import PreciousMetalsLoader from './Loader/PreciousMetalsLoader';
import { messages } from '../../helpers/messages';
import { Message } from '../utilites';
import { permissionsAccess } from '../../helpers/common';

const PreciousMetals = () => {
  const [state, setState] = useState({
    date: '',
    dateEntered: false,
    showModalMetal: false,
    purityGroups: [],
    entity: undefined,
    purityGroup: undefined,
    loading: false,
    error: '',
  });

  const handleOpenModalMetal = (purityGroup) => {
    if (!state.dateEntered) {
      let entity = {
        startDate: moment().utcOffset(0, true).toISOString().substr(0, 10),
        prices: purityGroup.prices
          .filter(price => price.active)
          .map(({ price, id }) => ({ price, id })),
      };
      setState((prev) => ({
        ...prev,
        showModalMetal: true,
        entity,
        purityGroup,
      }));
    }
  };

  const handleCloseModalMetal = () => {
    setState((prev) => ({
      ...prev,
      showModalMetal: false,
      error: '',
    }));
  };

  const handleSubmit = (entity) => {
    let purityGroup = state.purityGroup;
    entity.startDate = entity.startDate.toISOString();
    entity.prices.forEach((item, index) => {
      item.id = state.entity.prices[index].id;
    });
    entity.type = purityGroup.name;
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    cashBoxService
      .updatePurities(entity)
      .then((response) => {
        setState((prev) => ({
          ...prev,
          purityGroups: response.data.purityGroups,
          futurePurityGroups: response.data.futurePurityGroups,
        }));
        handleCloseModalMetal();
      })
      .catch((error) => {
        if (error.response) {
          let errorData = error.response.data;
          let commonError = messages['0'];
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode];
          }
          setState((prev) => ({
            ...prev,
            error: commonError,
          }));
        }
      })
      .finally(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      })
  };

  useEffect(() => {
    loadPurityGroups();
  }, []);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const loadPurityGroups = (date) => {
    setState((prev) => ({
      ...prev,
      loading: true,
      dateEntered: !!date,
    }));
    cashBoxService
      .getPurityGroups(date)
      .then((response) => {
        setState((prev) => ({
          ...prev,
          purityGroups: response.data.purityGroups,
          futurePurityGroups: response.data.futurePurityGroups,
        }));
      })
      .finally(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      });
  };

  const changeDate = () => {
    loadPurityGroups(state.date);
  };
  
  let loading = state.loading;

  return (
    <div className="content-inner-data-container">
      <div className="content-datatable">
        <div className="content-datatable-header">
          <div className="content-datatable-header-right">
            <div className="action-items">
              <input
                className="input action-item"
                type="date"
                id="date"
                name="date"
                value={state.date}
                onChange={handleChange}
                max="2100-01-01"
              />
              <button className="action-item" onClick={changeDate}>
                Просмотреть
              </button>
            </div>
          </div>
        </div>
        <div className="content-datatable-content">
          <fieldset>
            {loading
              ? <PreciousMetalsLoader/>
              : <>
                {state.purityGroups.map((purityGroup, index) => {
                  const { name, prices } = purityGroup;
                  return (
                    <div key={index} className="content-card purity-group-card">
                      <div className="content-card-title">
                        <h3>{name}</h3>
                        { permissionsAccess("action.purities.update")
                         &&
                          <div className="content-card-title-actions">
                            <button
                              className={
                                (state.dateEntered ? 'button-icontrigger-disabled' : '') +
                                ' button-icontrigger caption noborder'
                              }
                              onClick={() => handleOpenModalMetal(purityGroup)}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                              <span>Редактировать</span>
                            </button>
                          </div>
                        }
                      </div>
                      <div className="content-card-content">
                        {prices.map((price, index) => {
                          return (
                            <div
                              key={index}
                              className={
                                'form-element inline' +
                                (state.dateEntered || price.active ? '' : ' disabled')
                              }>
                              <label
                                className={
                                  'form-element-label' +
                                  (state.dateEntered || price.active ? '' : ' disabled')
                                }
                                htmlFor="#">
                                {price.name}
                              </label>
                              <div className="form-element-data">
                                <div className="form-element-data-text">
                                  <p>{price.price.toFixed(2)} BYN</p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>

            }
          </fieldset>
          {state.futurePurityGroups && (
            <div className="block-datacollapse">
              <Collapse className="">
                <Panel
                  header="Запланированные цены"
                  headerClass="block-datacollapse-header"
                  className="block-datacollapse-container">
                  <div className="block-datacollapse-content">
                    <fieldset>
                      {state.futurePurityGroups.map((purityGroup, index) => {
                        const { name, prices, startDate } = purityGroup;
                        return (
                          <div key={index} className="content-card purity-group-card">
                            <div className="content-card-title">
                              <h3>{name}</h3>
                              {startDate && (
                                <label className={'form-element-label'}>
                                  c {moment(startDate).format('DD.MM.yyyy')}
                                </label>
                              )}
                            </div>
                            <div className="content-card-content">
                              {prices.map((price, index) => {
                                return (
                                  <div key={index} className="form-element inline">
                                    <label className="form-element-label" htmlFor="#">
                                      {price.name}
                                    </label>
                                    <div className="form-element-data">
                                      <div className="form-element-data-text">
                                        <p>{price.price.toFixed(2)} BYN</p>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </fieldset>
                  </div>
                </Panel>
              </Collapse>
            </div>
          )}
          {state.purityGroup && (
            <ReactModal
              isOpen={state.showModalMetal}
              contentLabel="Modal"
              className="modal-container"
              overlayClassName="modal-overlay">
              <HookForm
                onSubmit={handleSubmit}
                validationSchema={purityGroupScheme}
                defaultValues={state.entity}
                submitOnEnterPress={true}>
                <div className="modal-header">
                  <div className="">
                    <h2>Редактирование драгоценного металла</h2>
                    <div className="form-element m-t-spacer">
                      <label className="form-element-label" htmlFor="">
                        Применить с
                      </label>
                      <div className="form-element-data date">
                        <HInput
                          h="true"
                          className="input"
                          type="date"
                          name={`startDate`}
                          id={`startDate`}
                          max="2100-01-01"
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    className="button-icontrigger modal-closetrigger"
                    onClick={handleCloseModalMetal}>
                    <span className="icon">
                      <CrossIcon />
                    </span>
                  </button>
                </div>
                <div className="modal-body modal-body__height">
                  {state.error && <Message type={"error"} text={state.error}/>}
                  <fieldset>
                    <div className="content-section-title">
                      <h3>{state.purityGroup.name}</h3>
                    </div>
                    {state.purityGroup.prices.filter(price => price.active).map((pr, index) => {
                      return (
                        <div key={index} className="form-element inline">
                          <label className="form-element-label" htmlFor="goldEdit">
                            {pr.name}
                          </label>
                          <div className="form-element-data number">
                            <HInput
                              className="input"
                              h={'true'}
                              type="text"
                              autoComplete="off"
                              name={`prices[${index}].price`}
                              id={`prices${index}.price`}
                              placeholder="руб."
                              decimals={2}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </fieldset>
                </div>
                <div className="modal-footer">
                  <button className="button">Сохранить</button>
                  <button className="button-light" onClick={handleCloseModalMetal}>
                    Отменить
                  </button>
                </div>
              </HookForm>
            </ReactModal>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreciousMetals;
